import React, { useState, Component } from "react";
import {
  StyleSheet,
  Keyboard,
  TextInput,
  TouchableOpacity,
} from "react-native";

import { Text, View, Input, Button } from "native-base";

import Modal from "modal-enhanced-react-native-web";

import { MyCart, Constant } from "./Data.js";

export class MenuItemModal extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      item: props.item,
      commentBarText: "",
    };
  }

  addToCart = () => {
    const updatedItem = this.state.item;
    updatedItem["comment"] = this.state.commentBarText;
    updatedItem["key"] = idGenerator();
    let copiedItem = Object.assign({}, updatedItem);
    this.props.onAddToCart(copiedItem);
    this.closeModal();
  };

  closeModal = () => {
    this.setState({ visible: false });
    Keyboard.dismiss();
  };

  openModal = () => {
    this.setState({ visible: true, commentBarText: "" });
  };

  render() {
    return (
      <Modal
        isVisible={this.state.visible}
        visible={this.state.visible}
        backdropColor="black"
        backdropOpacity={0.8}
        animationOut="slideOutDown"
        animationIn="bounceIn"
        avoidKeyboard={true}
        onBackdropPress={() => this.closeModal()}
        onBackButtonPress={() => this.closeModal()}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Text style={styles.itemTitle}>{this.state.item.title}</Text>
              <Text style={styles.itemPrice}>${this.state.item.price}</Text>
            </View>
            <DescriptionElement description={this.state.item.description} />
            <TextInput
              style={styles.commentBarInput}
              multiline={false}
              placeholder="Personalization"
              value={this.state.commentBarText}
              maxLength={270}
              onChangeText={(text) => this.setState({ commentBarText: text })}
            />

            <TouchableOpacity
              style={styles.addToCartButton}
              onPress={() => this.addToCart()}
            >
              <Text style={styles.addToCartButtonText}>Add to Order</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    );
  }
}

function DescriptionElement(props) {
  if (props.description === " " || props.description === "") {
    return null;
  } else {
    return <Text style={styles.itemDescription}>{props.description}</Text>;
  }
}

const styles = StyleSheet.create({
  centeredView: {
    justifyContent: "center",
    alignItems: "center",
  },
  modalView: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 32,

    width: "90%",
  },
  itemTitle: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: 20,
    fontFamily: Constant.font,
    fontWeight: "700",
  },
  itemPrice: {
    fontSize: 20,
    fontFamily: Constant.font,
    fontWeight: "700",
    marginLeft: 12,
  },
  itemDescription: {
    marginTop: 8,
    marginBottom: 0,
    fontSize: 16,
    fontFamily: Constant.font,
    fontWeight: "400",
    color: "gray",
  },
  commentBar: {
    height: 60,
    borderRadius: 4,
  },
  commentBarInput: {
    shadowOpacity: 0.0,
    borderColor: "#d3d3d3",
    borderWidth: 1,
    borderRadius: 4,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 16,
    fontFamily: Constant.font,
    fontWeight: "300",
    textAlign: "center",
    marginTop: 16,
    marginBottom: 0,
  },
  addToCartButton: {
    marginTop: 8,
    backgroundColor: Constant.color1,
    borderRadius: 8,
    padding: 0,
    marginBottom: 0,
    height: 60,
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
  },
  addToCartButtonText: {
    color: "white",
    fontWeight: "600",
    fontSize: 18,
    fontFamily: Constant.font,
  },
});

function idGenerator() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}
